import { ApiResponse } from '../models/apiResponse';
import { MarketingBanners } from '../models/marketingStoreModels';
import { apiRequests as requests } from './http-client';
import { FIVE_MINUTE_GET_CACHE_CONFIG } from './cache-config';

const Banners = {
  banners: (country: string) =>
    requests
      .get<
        ApiResponse<MarketingBanners[]>
      >(`/v1/banners/${country}`, FIVE_MINUTE_GET_CACHE_CONFIG)
      .then((response) => response.data),
};

export default Banners;
